module.exports = __webpack_public_path__ + "d308073b/img/share-action-icon.9c12578c.svg";